import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_FILECATEGORIES = "filecategories";
const BASE_URL = "/api/filecategories";

const FilecategoryQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const FILECATEGORIES_EMPTY = {name: ""};

export function useFilecategorys() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_FILECATEGORIES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...FilecategoryQueryConfig
    });
    return {...result, filecategories: result.data};
}


export function useFilecategory(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_FILECATEGORIES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...FilecategoryQueryConfig
    });
    return {...result, filecategory: result.data};
}

export function useFilecategoryMutations() {
    async function createFunction(filecategory) {
        if (!filecategory) return;
        return await fetchPOST(BASE_URL, filecategory, false);
    }
    async function editFunction(filecategory) {
        if (!filecategory) return;
        return  await fetchPUT(`${BASE_URL}/${filecategory.id}`, filecategory);
    }
    async function deleteFunction(filecategory) {
        return await fetchDELETE(`${BASE_URL}/${filecategory.id}`)
    }

    return {
        createFilecategory: useMyMutation(createFunction, REACT_QUERY_ID_FILECATEGORIES, filecategory => `Filecategory ${filecategory.title} created`),
        editFilecategory: useMyMutation(editFunction, REACT_QUERY_ID_FILECATEGORIES, filecategory => `Filecategory ${filecategory.title} modified`),
        deleteFilecategory: useMyMutation(deleteFunction, REACT_QUERY_ID_FILECATEGORIES, filecategory => `Filecategory ${filecategory.title} deleted.`)
    };

}